<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="button" (click)="printGroups()" [class.disable]="!alarmGroupList?.length">
            {{ 'alarm-group.page.print-button' | translate }}
        </div>
    </div>

    <div class="content">
        <div class="table">
            <div class="table-header">
                <div class="header-td group-id-header" data-cy="alarm-group-table-group-no-label">
                    {{ 'alarm-group.page.table.header.num' | translate }}
                </div>
                <div class="header-td name-header" data-cy="alarm-group-table-group-name-label">
                    {{ 'alarm-group.page.table.header.name' | translate }}
                </div>
                <div class="header-td trigger-category-header" data-cy="alarm-group-table-category-label">
                    {{ 'alarm-group.page.table.header.category' | translate }}
                </div>
            </div>

            <div class="table-content">
                <div
                    class="tabl-data"
                    cdkDropList
                    [cdkDropListData]="alarmGroupList"
                    (cdkDropListDropped)="alarmGroupDrop($event)">
                    <div class="no-data" *ngIf="!alarmGroupList?.length">
                        {{ 'alarm-group.page.no-data-message' | translate }}
                    </div>
                    <app-alarm-group-row
                        class="table-row"
                        *ngFor="let alarmGroup of alarmGroupList; let index = index"
                        cdkDrag
                        [cdkDragDisabled]="!alarmGroupPageEditMode"
                        [alarmGroup]="alarmGroup"
                        [alarmGroupEditMode]="alarmGroupPageEditMode"
                        [index]="index"
                        [alarmGroupList]="alarmGroupList"
                        [vessel]="vessel"
                        [userCanEdit]="userCanEdit"
                        (onDuplicateRow)="duplicateRow(index)"
                        (onDeleteRow)="deleteRow(index)"
                        (onRowUpdated)="onGroupUpdated($event)"></app-alarm-group-row>
                </div>
                <div class="add-row-container">
                    <button
                        class="add-row-button"
                        data-cy="alarm-group-create-alarm-group-button"
                        *ngIf="!alarmGroupPageEditMode"
                        [disabled]="alarmGroupList.length >= maxAlarmGroups || !userCanEdit"
                        (click)="openCreateDialog()">
                        {{ 'alarm-group.page.footer.add' | translate }}
                    </button>

                    <div class="count-text">
                        {{
                            'alarm-group.page.group-count-text'
                                | translate
                                    : {
                                          count: alarmGroupList.length,
                                          count_max: maxAlarmGroups,
                                      }
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="loading-container">
    <app-loading-spinner [custom]="true" class="spinner-component" size="80" strokeWidth="3"></app-loading-spinner>
</div>
